// * External
import _ from "lodash";
import { connect } from "react-redux";
import React from "react";

// * Internal
import { getSelectedLearningCourseId } from "LearningCourse/modules/LearningCourseUtils";
import {
  getCourseId,
  getAcademicYearId,
  getSelectedCurriculumProgram,
  getCurrentCurriculumProgramType,
} from "modules/CommonSelectors";
import { STANDARD_UIDS } from "modules/Services/ServicesConstants";
import { useI18n } from "Hooks";

// * Relative
import AssessmentSubjectStandards from "./components/AssessmentSubjectStandards";
import AssessmentOtherLearningGoals from "./components/AssessmentOtherLearningGoals";
import { ASSESSMENT_LEARNING_GOALS_OPTIONS } from "./module/AssessmentLearningGoalsUtils";

const AssessmentLearningGoals = ({
  onClose,
  selectedLearningGoalKey,
  field_list,
  unitPlanFields,
  courseSubjects,
  updateInputField,
  assessmentFields,
  hasAddRemoveValues,
  assignmentSubjects,
  selectedLearningGoal,
  defaultOptions,
  unitPlanTemplate,
  getLearningGoalsTagCountTooltip,
  subFields,
  courseId,
  academicYearId,
  curriculumProgram,
  curriculumType,
  learningCourseId,
  assessmentId,
}) => {
  const { t } = useI18n();

  const isStandardsSelected =
    selectedLearningGoalKey === ASSESSMENT_LEARNING_GOALS_OPTIONS.STANDARDS ||
    _.includes(_.values(STANDARD_UIDS), selectedLearningGoalKey);

  const commonProps = {
    t,
    field_list,
    unitPlanFields,
    courseSubjects,
    updateInputField,
    assessmentFields,
    hasAddRemoveValues,
    assignmentSubjects,
    selectedLearningGoal,
    defaultOptions,
    unitPlanTemplate,
    getLearningGoalsTagCountTooltip,
    subFields,
    courseId,
    academicYearId,
    curriculumProgram,
    curriculumType,
    learningCourseId,
    onClose: onClose || _.noop,
    selectedLearningGoalKey,
    assessmentId,
  };

  /* Show SubjectStandards when "Standards" tab is selected or the field is a standards field (e.g. benchmarks, learningStandardUBD, learningStandardMYP, subjectStandardDP) */
  if (isStandardsSelected) {
    return <AssessmentSubjectStandards {...commonProps} />;
  }

  return <AssessmentOtherLearningGoals {...commonProps} />;
};

const mapStateToProps = state => {
  const courseId = getCourseId(state);
  const academicYearId = getAcademicYearId(state);
  const learningCourseId = getSelectedLearningCourseId(state);
  const curriculumProgram = getSelectedCurriculumProgram(state);
  const curriculumType = getCurrentCurriculumProgramType(state);

  return {
    courseId,
    academicYearId,
    learningCourseId,
    curriculumProgram,
    curriculumType,
  };
};

export default connect(mapStateToProps)(AssessmentLearningGoals);
